import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=6f88aacc&scoped=true"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"
import style0 from "./ProjectList.vue?vue&type=style&index=0&id=6f88aacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f88aacc",
  null
  
)

export default component.exports